import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from './ui/select'

export type PatternUnit = 'day' | 'month'

export interface RepeatPattern {
  on: number
  off: number
  unit: PatternUnit
}

interface PatternOption {
  label: string
  value: string
  pattern: RepeatPattern
}

const PRESET_PATTERNS: PatternOption[] = [
  { label: '7 Days on/off', value: '7-7', pattern: { on: 7, off: 7, unit: 'day' } },
  { label: '14 Days on/off', value: '14-14', pattern: { on: 14, off: 14, unit: 'day' } },
  { label: '21 Days on/off', value: '21-21', pattern: { on: 21, off: 21, unit: 'day' } },
  { label: '30 Days on/off', value: '30-30', pattern: { on: 30, off: 30, unit: 'day' } },
  { label: '60 Days on/off', value: '60-60', pattern: { on: 60, off: 60, unit: 'day' } },
]

function patternToValue(pattern: RepeatPattern | null | undefined, isCustom: boolean): string {
  if (isCustom) return 'custom'
  if (!pattern) return 'none'
  const match = PRESET_PATTERNS.find(
    (p) => p.pattern.on === pattern.on && p.pattern.off === pattern.off && p.pattern.unit === pattern.unit
  )
  return match ? match.value : 'none'
}

interface RepeatPatternSelectProps {
  selectedPattern?: RepeatPattern | null
  isCustomPattern?: boolean
  customDaysOn?: number | null
  customDaysOff?: number | null
  onSelect: (pattern: RepeatPattern | 'custom' | null) => void
  disabled?: boolean
}

export function RepeatPatternSelect({
  selectedPattern,
  isCustomPattern,
  customDaysOn,
  customDaysOff,
  onSelect,
  disabled,
}: RepeatPatternSelectProps) {
  const currentValue = patternToValue(selectedPattern, !!isCustomPattern)
  const hasCustomPattern = customDaysOn != null && customDaysOff != null
  const customLabel = hasCustomPattern ? `Custom (${customDaysOn} on / ${customDaysOff} off)` : 'Custom'

  return (
    <Select
      value={currentValue}
      onValueChange={(val) => {
        if (val === 'none') {
          onSelect(null)
        } else if (val === 'custom') {
          onSelect('custom')
        } else {
          const option = PRESET_PATTERNS.find((p) => p.value === val)
          if (option) onSelect(option.pattern)
        }
      }}
      disabled={disabled}
    >
      <SelectTrigger className="h-8 w-full">
        <SelectValue placeholder="None" />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value="none">None</SelectItem>
        {PRESET_PATTERNS.map((option) => (
          <SelectItem key={option.value} value={option.value}>
            {option.label}
          </SelectItem>
        ))}
        <SelectItem value="custom">{customLabel}</SelectItem>
      </SelectContent>
    </Select>
  )
}
